import {Col, Divider, Row} from "antd";
import Text from "antd/es/typography/Text";
import React, {Component} from "react";
import "./c240_header.css";
import {Box, LinearProgress} from "@mui/material";
import {sagaMiddleware} from "../../helper/store";
import {watchPollMachineStatusBar} from "../../redux_actions/c240_device_status.action";
import {connect} from "react-redux";


const taskToDisplayMessageMap = {
    OPEN_GATE_WITHOUT_CASSETTE_ON_STAGE : "Opening Gate",
    OPEN_GATE_WITH_CASSETTE_ON_STAGE : "Opening Gate",
    CLOSE_GATE : "Closing Gate",
    TAKE_PREVIEW_SAME_CASSETTE : "Taking Preview",
    TAKE_PREVIEW_NEW_CASSETTE_WITH_CASSETTE_ON_STAGE : "Taking Preview",
    TAKE_PREVIEW_NEW_CASSETTE_WITHOUT_CASSETTE_ON_STAGE : "Taking Preview",
    TAKE_SCAN_SAME_CASSETTE: "Taking Scan",
    TAKE_SCAN_NEW_CASSETTE_WITH_CASSETTE_ON_STAGE: "Taking Scan",
    TAKE_SCAN_NEW_CASSETTE_WITHOUT_CASSETTE_ON_STAGE: "Taking Scan",
    TAKE_BARCODE: "Taking barcode",
    PUT_CASSETTE_IN_RACK: "Putting cassette in rack",
    CLOSING_FRONT_GATE: "Closing gate",
    UNLOCKING_BACK_GATE: "Unlocking back gate",
    MOVING_LOADER_TO_SAFE_POS: "Moving loader to safe place",
    PICKING_CASSETTE_FROM_STAGE: "Picking cassette from stage",
    PUTTING_CASSETTE_IN_RACK: "Putting cassette in rack",
    LOCKING_BACK_GATE: "Locking back gate",
    OPENING_FRONT_GATE: "",
    GRABBING_CASSETTE_FROM_RACK: "Grabbing cassette from rack",
    PUTTING_CASSETTE_ON_STAGE: "Unloading cassette on stage",
    TAKING_BARCODE_SLIDE1: "Taking barcode (Slide 1)",
    TAKING_BARCODE_SLIDE2: "Taking barcode (Slide 2)",
    TAKING_BARCODE_SLIDE3: "Taking barcode (Slide 3)",
    TAKING_BARCODE_SLIDE4: "Taking barcode (Slide 4)",
    TAKING_BARCODE_SLIDE5: "Taking barcode (Slide 5)",
    TAKING_BARCODE_SLIDE6: "Taking barcode (Slide 6)",
    TAKING_PREVIEW: "",
    TAKING_SCAN: "",
    "": "",
    WAITING_FOR_USER_TO_CLOSE_GATE: "Please close the Gate to resume queue",
    WAITING_FOR_USER_TO_CALIBRATE_PREVIEW: "[Action Required] Please calibrate scan to resume queue",
    IDLE: "Machine is idle.",
    RECALIBRATING_SCANNER: "Calibrating"
}


class C240MachineStatusBar extends Component {

    constructor(props) {
        super(props);
        this.state ={

        }
    }

    componentDidMount() {
        this.poller = sagaMiddleware.run(watchPollMachineStatusBar, this.props.dispatch);
    }

    componentWillUnmount() {
        this.poller.cancel();
    }

    render() {
        let machineStatus = this.props.c240DeviceStatus.machineStatus;
        let displayStatusText = "";
        let displayProgressBar = false;
        if (machineStatus === null || machineStatus === undefined || machineStatus["task"] === "IDLE") {
            displayStatusText = "Machine is idle.";
        } else {
            displayStatusText = taskToDisplayMessageMap[machineStatus["task"]];

            if (taskToDisplayMessageMap[machineStatus["subTask"]] !== "") {
                displayStatusText = taskToDisplayMessageMap[machineStatus["subTask"]];
                displayProgressBar = true;
            }
        }

        return (
            <div className={"status-bar"}>
                <Row type={"flex"} style={{justifyContent: "space-between", alignItems: "center"}}>
                    <Col span={displayProgressBar ? 12 : 24}>
                        <Text style={{fontSize: "14px"}}>
                            {displayStatusText}
                        </Text>
                    </Col>
                    {displayProgressBar ? <>
                        <Col style={{display: "flex", justifyContent: "center", alignItems: "center"}} span={12}>
                            <Divider style={{borderLeft: "1px solid #17202A"}} type={"vertical"} />
                            <Box sx={{width: "100%"}}>
                                <LinearProgress variant="buffer" value={parseFloat(machineStatus["progress"])} valueBuffer={parseFloat(machineStatus["buffer"])} className={"progress-bar"} />
                            </Box>
                            <Text style={{textAlign: "center", marginLeft: "5px"}}>{parseFloat(machineStatus["progress"]) + "%"}</Text>
                        </Col>
                    </> : null}
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        c240DeviceStatus: state.c240DeviceStatusReducer
    };
};

export default connect(mapStateToProps)(C240MachineStatusBar);